module.exports = __webpack_public_path__ + "static/1344505185.a57cdfaa.jpg";